/**
 * 空间运算类
 */
export default {

  /**
   * Description: 判断点是不是在圆内
   * @author: lhc
   * @date: 2022/8/12 9:32
   */
  ptInCircle(point, centerPoint, radius) {
    var pArr = point.split(',')
    var p = {}
    p.x = Number(pArr[0])
    p.y = Number(pArr[1])

    pArr = centerPoint.split(',')
    var cp = {}
    cp.x = Number(pArr[0])
    cp.y = Number(pArr[1])

    var pEz = new EzCoord(p.x, p.y)
    var cpEz = new EzCoord(cp.x, cp.y)

    var distance = pEz.distanceTo(cpEz)

    console.log('distance', distance)

    return distance <= radius
  },

  /**
   * Description:   判断后坐标是否在区域内
   * @author: lhc
   * @date: 2022/8/11 16:37
   * @return {boolean}
   */
  PtInPolygon(point, polygon) {
    var pArr = []
    if (Array.isArray(point)) {
      pArr = point
    } else {
      pArr = point.split(',')

    }
    var p = {}
    p.x = parseFloat(pArr[0])
    p.y = parseFloat(pArr[1])
    var pt = []
    var gArr = polygon.split(',')
    var num = gArr.length
    for (var i = 0; i < num; i++) {
      var p1 = {}
      p1.x = parseFloat(gArr[i])
      p1.y = parseFloat(gArr[++i])
      pt.push(p1)
    }

    var nCount = pt.length
    var nCross = 0
    for (var i = 0; i < nCount; i++) {
      var p1 = pt[i]
      var p2 = pt[(i + 1) % nCount]
      if (p1.y === p2.y) {
        if (p.y === p1.y && p.x >= min(p1.x, p2.x) && p.x <= max(p1.x, p2.x)) return true
        continue
      }
      if (p.y < min(p1.y, p2.y) || p.y > max(p1.y, p2.y))
        continue
      var x = (p.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x
      if (x > p.x)
        nCross++
      else if (x === p.x)
        return true
    }
    console.log('nCross', nCross)
    if (nCross % 2 === 1) return true
    return false
  },


  /**
   * Description:   判断后坐标是否在区域内
   * @author: lhc
   * @date: 2023/1/3 13:51
   * @return {boolean}
   */
  PtInPolygonEnclave(point, polygon) {
    let result = false
    var pArr = []
    if (Array.isArray(point)) {
      pArr = point
    } else {
      pArr = point.split(',')

    }
    var p = {}
    p.x = parseFloat(pArr[0])
    p.y = parseFloat(pArr[1])
    var polygonArr = polygon.split(';')
    for (var i = 0; i < polygonArr.length; i++) {
      var pt = []
      var gArr = polygonArr[i].split(',')
      var num = gArr.length
      for (var j = 0; j < num; j++) {
        var p1 = {}
        p1.x = parseFloat(gArr[j])
        p1.y = parseFloat(gArr[++j])
        pt.push(p1)
      }

      var nCount = pt.length
      var nCross = 0
      for (var z = 0; z < nCount; z++) {
        var p1 = pt[z]
        var p2 = pt[(z + 1) % nCount]
        if (p1.y === p2.y) {
          if (p.y === p1.y && p.x >= min(p1.x, p2.x) && p.x <= max(p1.x, p2.x)) result = true
          break
        }
        if (p.y < min(p1.y, p2.y) || p.y > max(p1.y, p2.y))
          continue
        var x = (p.y - p1.y) * (p2.x - p1.x) / (p2.y - p1.y) + p1.x
        if (x > p.x)
          nCross++
        else if (x === p.x) {
          result = true
          break
        }
      }
      if (nCross % 2 === 1) {
        result = true
        break
      } else {
        result = false
      }
    }
    return result
  },

  /**
   * Description: 判断后坐标区域是否在区域内
   * @author: lhc
   * @date: 2022/8/11 16:39
   */
  AreaInPolygon(area, polygon) {
    var pArr = area.split(',')
    var polygonArr = polygon.split(';')
    for (var j = 0; j < polygonArr.length; j++) {
      var flag = true
      for (var i = 0; i < pArr.length; i += 2) {
        var point = pArr[i] + ',' + pArr[i + 1]
        if (!this.PtInPolygon(point, polygonArr[j])) {
          flag = false
          break
        }
      }
      if (flag) {
        return true
      }
    }
    return false
  },
}

/**
 * Description: 获取大值
 * @author: lhc
 * @date: 2022/8/11 16:34
 */
var max = function (x, y) {
  if (x < y) {
    return y
  } else {
    return x
  }
}

/**
 * Description:获取小值
 * @author: lhc
 * @date: 2022/8/11 16:35
 */
var min = function (x, y) {
  if (x > y) {
    return y
  } else {
    return x
  }
}
